export const createActionTypes = (actionTypes = {}, duckName = "DUCK") =>
  Object.keys(actionTypes).reduce(
    (res, key) => ({
      ...res,
      [key]: `${duckName.toUpperCase()}_DUCK/${actionTypes[key].toUpperCase()}`
    }),
    {}
  );
